<div class="row">
  <div class="icons text-primary col-sm-12 " style="text-align:center;font-size:48px;">
    <span class="icon-loading"></span>
  </div>

</div>
<div class="mb-4 row">

  <div class="col-12 text-center">
    @if(!isRLIndeferida){
    <p>{{  'WorkflowCreatePM.PreStage.SubmitPreStage.AlreadySentToRLSubmitPM' | translate}}</p>
    }
    @else{
    <p>{{  'WorkflowCreatePM.PreStage.SubmitPreStage.AlreadySentToRLSubmitPMInvalid' | translate}}</p>
    }

  </div>
</div>
